import Notifier from 'common/helpers/Notifier';

const SUCCESS_TIMEOUT_MS = 1500;
const ERROR_TIMEOUT_MS = 3000;

export const notifyTaskCreatedSuccess = () => {
  Notifier.dispatch('success', 'Task created successfully', SUCCESS_TIMEOUT_MS);
};

export const notifyTaskCreatedError = () => {
  Notifier.dispatch('error', 'Failed to create task', ERROR_TIMEOUT_MS);
};

export const notifyTaskReassignedSuccess = (count) => {
  Notifier.dispatch(
    'success',
    count === 1 ? 'Task reassigned successfully.' : 'Tasks reassigned successfully.',
    SUCCESS_TIMEOUT_MS,
  );
};

export const notifyTaskReassignedError = () => {
  Notifier.dispatch('error', 'Unable to reassign task(s). Please try again.', ERROR_TIMEOUT_MS);
};

export const notifyTaskStatusUpdatedSuccess = (status, count) => {
  const message = status === 'archived' ?
    `Task${count > 1 ? 's' : ''} archived successfully.` :
    `Task${count > 1 ? 's' : ''} marked as complete.`;

  Notifier.dispatch('success', message, SUCCESS_TIMEOUT_MS);
};

export const notifyTaskStatusUpdatedError = () => {
  Notifier.dispatch('error', 'Unable to update task status. Please try again.', ERROR_TIMEOUT_MS);
};
